import { render, staticRenderFns } from "./Clothes.vue?vue&type=template&id=cf7ca7ae&scoped=true&"
import script from "./Clothes.vue?vue&type=script&lang=js&"
export * from "./Clothes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7ca7ae",
  null
  
)

export default component.exports